import React from 'react';
import { X, ChevronLeft, ChevronRight, Play } from 'lucide-react';

const getYouTubeId = (url) => {
  if (!url) return null;
  const match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/);
  return match && match[2].length === 11 ? match[2] : null;
};

export const Lightbox = ({ items, selectedIndex, onClose, onPrevious, onNext }) => {
  if (selectedIndex === null) return null;
  const item = items[selectedIndex];

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center">
      <button onClick={onClose} className="absolute top-4 right-4 z-10 text-white hover:text-orange-500 transition-colors">
        <X size={32} />
      </button>

      {items.length > 1 && (
        <>
          <button onClick={onPrevious} className="absolute left-4 z-10 text-white hover:text-orange-500 transition-colors">
            <ChevronLeft size={48} />
          </button>
          <button onClick={onNext} className="absolute right-4 z-10 text-white hover:text-orange-500 transition-colors">
            <ChevronRight size={48} />
          </button>
        </>
      )}

      <div className="max-w-6xl max-h-[90vh] mx-4 flex flex-col">
        <div className="flex-1 flex items-center justify-center mb-4">
          {item.type === 'image' ? (
            <img src={item.url} alt={item.title || 'Gallery item'} className="max-w-full max-h-[80vh] object-contain" />
          ) : item.youtube_url ? (
            <div className="w-full max-w-4xl aspect-video">
              <iframe width="100%" height="100%"
                src={`https://www.youtube.com/embed/${getYouTubeId(item.youtube_url)}`}
                title={item.title || 'Video'} frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen className="rounded-lg" />
            </div>
          ) : (
            <video src={item.url} controls controlsList="nodownload" className="max-w-full max-h-[80vh] rounded-lg"
              onError={(e) => { try { if (e.target?.style) e.target.style.display = 'none'; } catch (err) { console.warn('Video load fallback:', err); } }} />
          )}
        </div>

        {(item.title || item.caption) && (
          <div className="bg-black/60 backdrop-blur-sm rounded-lg p-6 text-center">
            {item.title && <h3 className="text-2xl font-bold text-orange-500 mb-2">{item.title}</h3>}
            {item.caption && <p className="text-gray-300">{item.caption}</p>}
          </div>
        )}

        <div className="text-center text-gray-400 mt-4">{selectedIndex + 1} / {items.length}</div>
      </div>
    </div>
  );
};
